// Aux method to format data into the desired data model
export const dataFormatter = (rawData) => {
    // An index object in which all segregated data will be stored in
    const indexer = {
        // clinical_analysis: [],
        // vaccines:          [],
        // general:           []
    }

    // Loops through each item to push them into its corresponding service type array
    for (let i = 0; i < rawData.items.length; i++) {
        // Current iterator
        const item = rawData.items[i];

        if (!indexer[item.unity]) {
            indexer[item.unity] = [];
        }

        indexer[item.unity] = [
            ...indexer[item.unity],
            item
        ];

        // --- DEPRECATED ---
        // Fallback error for a mismatching attribute type
        // if (typeof item.categoryServiceType !== "string") {
        //     indexer.general.push(item);
        //
        //     continue;
        // }
        //
        // switch (item.categoryServiceType.toLowerCase()) {
        //     case "combos de vacinas":
        //     case "vacinas": {
        //         indexer.vaccines.push(item);
        //
        //         break;
        //     }
        //     case "checkups":
        //     case "análises clínicas": {
        //         indexer.clinical_analysis.push(item);
        //
        //         break;
        //     }
        //     default:
        //         indexer.general.push(item);
        // }
    }

    return {
        ...rawData,
        items: indexer
    }
}
